/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SingleTurnChatLanguageEnum } from './SingleTurnChatLanguageEnum';
import {
  SingleTurnChatLanguageEnumFromJSON,
  SingleTurnChatLanguageEnumFromJSONTyped,
  SingleTurnChatLanguageEnumToJSON,
} from './SingleTurnChatLanguageEnum';

/**
 * Create serializer for single-turn-chat generation inputs.
 * - Request: accept "knowledge_base" as a PK (id)
 * - Response: return nested "knowledge_base" object via `response_serializer`
 * @export
 * @interface SingleTurnChatGenerationInputsCreate
 */
export interface SingleTurnChatGenerationInputsCreate {
  /**
   *
   * @type {number}
   * @memberof SingleTurnChatGenerationInputsCreate
   */
  knowledgeBase: number;
  /**
   *
   * @type {string}
   * @memberof SingleTurnChatGenerationInputsCreate
   */
  description?: string;
  /**
   *
   * @type {SingleTurnChatLanguageEnum}
   * @memberof SingleTurnChatGenerationInputsCreate
   */
  language?: SingleTurnChatLanguageEnum;
  /**
   *
   * @type {any}
   * @memberof SingleTurnChatGenerationInputsCreate
   */
  examples?: any | null;
  /**
   *
   * @type {boolean}
   * @memberof SingleTurnChatGenerationInputsCreate
   */
  autoNSamples?: boolean;
  /**
   *
   * @type {number}
   * @memberof SingleTurnChatGenerationInputsCreate
   */
  nSamples?: number | null;
  /**
   *
   * @type {number}
   * @memberof SingleTurnChatGenerationInputsCreate
   */
  maxSamples?: number | null;
}

/**
 * Check if a given object implements the SingleTurnChatGenerationInputsCreate interface.
 */
export function instanceOfSingleTurnChatGenerationInputsCreate(
  value: object,
): value is SingleTurnChatGenerationInputsCreate {
  if (!('knowledgeBase' in value) || value['knowledgeBase'] === undefined) return false;
  return true;
}

export function SingleTurnChatGenerationInputsCreateFromJSON(json: any): SingleTurnChatGenerationInputsCreate {
  return SingleTurnChatGenerationInputsCreateFromJSONTyped(json, false);
}

export function SingleTurnChatGenerationInputsCreateFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): SingleTurnChatGenerationInputsCreate {
  if (json == null) {
    return json;
  }
  return {
    knowledgeBase: json['knowledge_base'],
    description: json['description'] == null ? undefined : json['description'],
    language: json['language'] == null ? undefined : SingleTurnChatLanguageEnumFromJSON(json['language']),
    examples: json['examples'] == null ? undefined : json['examples'],
    autoNSamples: json['auto_n_samples'] == null ? undefined : json['auto_n_samples'],
    nSamples: json['n_samples'] == null ? undefined : json['n_samples'],
    maxSamples: json['max_samples'] == null ? undefined : json['max_samples'],
  };
}

export function SingleTurnChatGenerationInputsCreateToJSON(value?: SingleTurnChatGenerationInputsCreate | null): any {
  if (value == null) {
    return value;
  }
  return {
    knowledge_base: value['knowledgeBase'],
    description: value['description'],
    language: SingleTurnChatLanguageEnumToJSON(value['language']),
    examples: value['examples'],
    auto_n_samples: value['autoNSamples'],
    n_samples: value['nSamples'],
    max_samples: value['maxSamples'],
  };
}
